Object.defineProperty(exports,"__esModule",{value:true});

function mod(n,m){
var q=n%m;
return q<0?q+m:q;
}exports.default=

mod;


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views-core/lib/mod.js
// module id = 252
// module chunks = 0